import { render, staticRenderFns } from "./journalOfClass.vue?vue&type=template&id=d8c864b2&scoped=true"
import script from "./journalOfClass.vue?vue&type=script&lang=js"
export * from "./journalOfClass.vue?vue&type=script&lang=js"
import style0 from "./journalOfClass.vue?vue&type=style&index=0&id=d8c864b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8c864b2",
  null
  
)

export default component.exports